<template>
    <div>
        <div class="tools-box">
            <div class="tools-item cursor" @click="showShopDrawer">
                <span class="icon-mall"></span>
                <div>关联店铺</div>
            </div>
            <div v-if="props.pro_info.pro_class == '101' && [0,1,2].includes(props.pro_info.status_code)" class="tools-item cursor" @click="goDrawTools">
                <span class="icon-gift"></span>
                <div>抽奖工具</div>
            </div>
            <div v-if="state.showLockerr" class="tools-item cursor" @click="showLockerrDrawer">
                <span class="icon-fans"></span>
                <div>关联lockerr粉丝群</div>
            </div>
            <el-popover
                placement="bottom-start"
                :width="260"
                trigger="hover"
            >
                <template #reference>
                    <div class="tools-item cursor">
                        <span class="icon-wechat"></span>
                        <div>商家活动顾问</div>
                    </div>
                </template>
                <div style="display:flex;align-items:center;flex-direction: column;">
                    <img style="width:200px;height:200px;" src="https://p6.moimg.net/mdwxapp/MD-12141.png" />
                    <p style="width:192px;font-size: 16px;color: #7F7F7F;line-height: 28px;text-align: center;">微信扫一扫，添加活动顾问获取最新活动和推广信息</p>
                </div>
            </el-popover>
            <div v-if="[0,1,2,3].includes(props.pro_info.status_code)" class="tools-item cursor" @click="goGoalTools">
                <img src="https://p6.moimg.net/mdwxapp/goal_icon.png" />
                <div>解锁目标</div>
            </div>
        </div>
        <!-- 
            众筹：众筹成功
            微打赏：项目结束 2 & 3
        -->
        <div class="address-box" v-if="pro_info.status_code == 3 || (pro_info.pro_class == '201' && pro_info.status_code == 2)">
            <span>用户修改地址及备注修改权限</span>
            <el-tooltip effect="dark" placement="top">
                <template #content>
                    <p>权限设置说明：</p>
                    <p>1、权限开启时：用户可随时修改订单地址及备注</p>
                    <p>2、权限关闭时：用户不可再修改订单地址及备注</p>
                    <p>3、此权限默认打开，支持手动修改权限开关状态</p>
                    <p>4、导出发货单时，系统默认关闭此权限</p>
                </template>
                <span class="icon-warning icon cursor"></span>
            </el-tooltip>
            <el-switch 
                v-model="state.switch" 
                :before-change="beforeChangeColumn"
                @change="switchChange"
                :active-value="0"
                :inactive-value="1"
                active-color="#00C4A1" 
                inactive-color="#B1B1B1"></el-switch>
        </div>
        <!-- 关联店铺 -->
        <el-drawer v-model="state.shopDrawer" title="众筹关联店铺设置"
            size="400px"
            :closeOnClickModal="false">
            <div class="tools-drawer">
                <div class="tools-drawer-tit">众筹信息</div>
                <div class="tools-drawer-item">
                    <label>项目ID</label>
                    <p>{{ props.pro_info.id }}</p>
                </div>
                <div class="tools-drawer-item">
                    <label>项目标题</label>
                    <p>{{ props.pro_info.title }}</p>
                </div>
                <div v-if="state.hasRelate" class="tools-drawer-tit tools-drawer-tit-m">已关联的店铺</div>
                <template v-else>
                    <div class="tools-drawer-tit tools-drawer-tit-m">店铺信息</div>
                    <div class="tools-drawer-item">
                        <label class="label-input">店铺ID</label>
                        <el-input class="input" v-model="state.shop_id" placeholder="请输入店铺ID"></el-input>
                        <el-button class="btn" @click="search">搜索</el-button>
                    </div>
                </template>
                <div class="shop-info" v-if="state.hasRelate">
                    <div class="tools-drawer-item">
                        <label>店铺ID</label>
                        <p>{{state.relationInfo.shop_id}}</p>
                    </div>
                    <div class="tools-drawer-item">
                        <label>店铺名称</label>
                        <p>{{state.relationInfo.name}}</p>
                    </div>
                    <div class="tools-drawer-item">
                        <label>店主UID</label>
                        <p>{{state.relationInfo.user_id}}</p>
                    </div>
                    <div class="tools-drawer-item">
                        <label>店主昵称</label>
                        <p>{{state.relationInfo.user_name}}</p>
                    </div>
                    <div class="shop-info-btn">
                        <el-button @click="del">取消关联</el-button>
                        <el-button @click="edit">修改关联</el-button>
                    </div>
                </div>
                <div class="shop-info" v-else-if="state.shopInfo.shop_id">
                    <div class="tools-drawer-item">
                        <label>店铺名称</label>
                        <p>{{state.shopInfo.name}}</p>
                    </div>
                    <div class="tools-drawer-item">
                        <label>店主UID</label>
                        <p>{{state.shopInfo.user_id}}</p>
                    </div>
                    <div class="tools-drawer-item">
                        <label>店主昵称</label>
                        <p>{{state.shopInfo.user_name}}</p>
                    </div>
                    <div class="shop-info-btn">
                        <el-button type="primary" @click="add">确认关联</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
        <!-- 关联lockerr粉丝群 -->
        <el-drawer 
            v-model="state.lockerrDrawer" 
            :title="state.is_bind ? 'Lockerr社群工具' : '众筹关联店铺设置'"
            :size="state.is_bind ? '600px' : '400px'"
            :closeOnClickModal="false"
            @close="lockerrDrawerClose">
            <div class="lockerr-drawer">
                <template v-if="state.is_bind && !state.showEWM">
                    <div class="lockerr-drawer-bind-item">
                        <label>当前关联lockerr账号</label>
                        <span class="info">{{ state.lockerrUserInfo.phone }}（手机号）</span>
                        <el-button size="small" @click="updateLockerr">更换关联账号</el-button>
                    </div>
                    <div v-if="state.brandName" class="lockerr-drawer-bind-item">
                        <label>当前关联lockerr账号</label>
                        <span class="info">{{ state.brandName }}</span>
                        <el-button size="small" @click="state.brandName = ''">更换关联品牌</el-button>
                    </div>
                    <div v-else class="lockerr-drawer-bind-item">
                        <label>关联lockerr品牌</label>
                        <el-select v-model="state.brand" placeholder="请选择" class="info">
                            <el-option
                                v-for="item in state.brandList"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </template>
                <template v-else>
                    <div class="img" style="width: 140px; height: 140px; overflow: hidden;">
                        <div ref="qrCodeUrl"></div>
                    </div>
                    <p class="qr-tips">请用微信扫码，关联 Lockerr 账户</p>
                </template>
            </div>
            <template #footer v-if="state.is_bind && !state.showEWM">
                <el-button type="primary" @click="submit">确认</el-button>
            </template>
        </el-drawer>
    </div>
</template>

<script setup>
import tools from '@/utils/tools.js'
import QRCode from 'qrcodejs2'

import { ElMessage } from "element-plus";
import { reactive, defineProps, computed, ref } from "vue";
import { onMounted, watch } from "@vue/runtime-core";
import { useStore } from 'vuex'
import { addressLock, getRelationInfo, delRelation, getShopInfo, addRelation, createUserToken, lockerrModianUser, getBrandList, bindingBrand, OpenLockerrStatus } from "@/api/index"

const props = defineProps({
    pro_id: String,
    pro_info: Object
})
const state = reactive({
    switch: 0,
    shopDrawer: false,
    relationInfo: {}, // 已关联的店铺信息
    hasRelate: false, // 是否关联店铺
    shop_id: '',
    shopInfo: {},
    lockerrDrawer: false, // 关联lockerr粉丝群抽屉
    showEWM: false, // 是否显示二维码
    is_bind: false, // 是否绑定
    selectBrandId: '', // 暂存已选品牌id
    brand: '', // 已选品牌
    brandName: '',
    brandList: [], // 品牌列表
    oldToken: '',
    lockerrUserInfo: {},
    showLockerr: false,
})
const store = useStore()
state.userId = computed(() => {
    return store.state.user.user_id
})
watch(() => {[props.pro_info]}, () => {
    state.switch = props.pro_info.process_status || 0
}, { deep: true, immediate: true })

onMounted(() => {
    ifShowLockerr()
})

const beforeChangeColumn = () => {
    state.switchState = true
    return state.switchState
}
// 用户修改地址及备注修改权限
const switchChange = (val) => {
    if (state.switchState) {
        addressLock({
            pro_id: props.pro_id,
            lock_statusint: val
        })
    }
}
const showShopDrawer = async () => {
    await getRelation()
    state.shopDrawer = true
}
const goDrawTools = () => {
    window.location.href = `/operate_manage/drawtool/create?pro_id=${props.pro_id}&item_type=2`;
}
const goGoalTools = () => {
    window.location.href = `/operate_manage/goals/${props.pro_id}`;
}
// 获取店铺关联信息
const getRelation = async () => {
    const res = await getRelationInfo({
        pro_id: props.pro_id
    })
    if (res.status == 0) {
        if (res.data && res.data.id) {
            state.relationInfo = res.data
            state.hasRelate = true
        } else {
            state.hasRelate = false
        }
    }
}
// 关联
const add = () => {
    addRelation({
        pro_id: props.pro_id,
        shop_id: state.shopInfo.shop_id,
        id: state.relationInfo.id || ''
    }).then(res => {
        if(res.status == 0) {
            ElMessage({
                type: 'info',
                customClass: 'info-customize',
                message: res.message || '关联成功',
            });
            state.relationInfo = state.shopInfo
            state.hasRelate = true
        } else {
            ElMessage({
                type: 'warning',
                customClass: 'waring-customize',
                message: res.message || '关联失败',
            });
        }
    })
}
// 取消关联
const del = () => {
    tools.confirm({
        hasCancel:true,
        cancel:'取消',
        success:'确定',
        msg: '确定解除店铺关联？'
    }, () => {
        delRelation ({
            pro_id: props.pro_id,
            id: state.relationInfo.id
        }).then(({status, data, message}) => {
            if (status == 0 && data) {
                ElMessage({
                    type: 'info',
                    customClass: 'info-customize',
                    message: message || '成功解除店铺关联',
                });
                state.relationInfo = {}
                state.shopInfo = {}
                state.hasRelate = false
            } else {
                ElMessage({
                    type: 'warning',
                    customClass: 'waring-customize',
                    message: message || '解除失败',
                });
            }
        })
    })
}
// 修改关联
const edit = () => {
    state.shopInfo = {}
    state.hasRelate = false
}
// 搜索店铺信息
const search = () => {
    if (!state.shop_id) return
    getShopInfo({
        shop_id: state.shop_id
    }).then(res => {
        if(res.status == 0) {
            state.shopInfo = res.data
            state.shop_id = ''
        } else {
            ElMessage({
                type: 'info',
                customClass: 'info-customize',
                message: res.message || '未搜到店铺信息',
            });
        }
    })
}
// 显示lockerr抽屉
const showLockerrDrawer = async () => {
    state.lockerrDrawer = true
    await getLockerr()
}
var timer = null
// 获取lockerr 相关user 
const getLockerr = async () => {
    const { status, data } = await lockerrModianUser({
        user_id: state.userId,
        project_id: props.pro_id,
        token: state.oldToken || ''
    })
    if (status == 0) {
        state.selectBrandId = data.select_brand_id
        state.is_bind = data.is_bind
        // 已绑定
        if (data.is_bind) {
            clearTimeout(timer);
            state.lockerrUserInfo = data.lockerr_user_info
            await getBrand()
            state.selectBrandId = data.select_brand_id
            state.brand = data.select_brand_id
            if (data.select_brand_id) {
                let index = state.brandList.findIndex(item => {
                    return item.id == data.select_brand_id
                })
                if (index > -1) {
                    state.brandName = state.brandList[index].title
                }
            }
        } else {
            if (data.token_check == 'success' && !data.token) {
                clearTimeout(timer);
            } else {
                timer = setTimeout(async() => await getLockerr(), 3000)
                if (data.token && state.oldToken !== data.token) {
                    creatQrCode(data.token)
                    state.oldToken = data.token
                }
            }
        }
    } else {
        clearTimeout(timer);
    }
}
const getBrand = async () => {
    const { status, data } = await getBrandList({
        lockerr_user_id: state.lockerrUserInfo.user_id
    })
    if (status == 0) {
        state.brandList = data.ips
    }
}
// 确认
const submit = async () => {
    if (state.brand && !state.brandName) {
        const res = await bindingBrand({
            project_id: props.pro_id,
            lockerr_brand_id: state.brand,
            lockerr_brand_old_id: state.selectBrandId
        })
        if (res.status == 0) {
            ElMessage({
                type: 'info',
                customClass: 'info-customize',
                message: res.message || '绑定成功',
            });
            state.lockerrDrawer = false
        }
    } else {
        state.lockerrDrawer = false
    }
}
// 获取临时token
const createLockerr = async () => {
    const res = await createUserToken({
        user_id: state.userId
    })
    if (res.status == 0) {
        creatQrCode(res.data)
    }
}
// 二维码
const qrCodeUrl = ref(null);
// 生成二维码
const creatQrCode = (token) => {
    new QRCode(qrCodeUrl.value, {
        text: token,
        width: 1280,
        height: 1280,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
    })
}
// 更换关联账号
const updateLockerr = async () => {
    state.showEWM = true
    await createLockerr()
    clearTimeout(timer)
    getLockerr()
}
// lockerr抽屉关闭
const lockerrDrawerClose = () => {
    clearTimeout(timer);
}
// 判断是否显示“关联lockerr粉丝群”按钮
const ifShowLockerr = () => {
    OpenLockerrStatus({
        project_id: props.pro_id
    }).then(res => {
        if (res.status == 0 && res.data) {
            state.showLockerr = true
        } else {
            state.showLockerr = false
        }
    })
}
</script>

<style lang="scss" scoped>
.tools-box {
    display: flex;
    justify-content: space-between;
    line-height: 1;
    margin-top: 16px;
    padding-bottom: 20px;
    flex-wrap: wrap;
    .tools-item {
        width: calc((100% - 20px) / 2);
        height: 84px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img{
            width: 40px;
            height: auto;
        }
        span {
            font-size: 30px;
        }
        div {
            margin-top: 14px;
        }
    }
}
.address-box {
    border-top: 1px solid #F2F2F2;
    padding-top: 14px;
    margin-bottom: -6px;
    display: flex;
    align-items: center;
    .icon {
        color: #7F7F7F;
        margin: 0 auto 0 5px;
        font-size: 16px;
    }
}
.cursor {
    cursor: pointer;
}
.tools-drawer {
    .tools-drawer-tit {
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 16px;
        &-m {
            padding-top: 16px;
        }
    }
    .tools-drawer-item {
        display: flex;
        line-height: 21px;
        padding-bottom: 12px;
        label {
            width: 84px;
            &.label-input {
                align-self: center;
            }
        }
        p {
            flex: 1;
        }
        .input {
            flex: 1;
        }
        .btn {
            margin-left: 10px;
        }
    }
    .shop-info {
        margin-top: 10px;
        background-color: #F8F8F8;
        border-radius: 6px;
        padding: 6px 0 10px;
        .tools-drawer-item {
            padding-left: 10px;
            padding-right: 10px;
        }
        &-btn {
            padding: 10px 10px 0 0;
            border-top: 1px solid #E8E8E8;
            text-align: right;
        }
    }
}
.lockerr-drawer {
    .img {
        margin: 36px auto 6px;
    }
    .qr-tips {
        color: #7F7F7F;
        text-align: center;
    }
    .lockerr-drawer-bind-item {
        display: flex;
        align-items: center;
        padding-bottom: 14px;
        label {
            width: 160px;
        }
        .info {
            flex: 1;
        }
    }
}
</style>
